module.exports = __webpack_public_path__ + "static/img/1.e4b7f406.jpg";